const size500KB = 512000;   // 500 KB MAX
const fileSize = 5242880;  // 5 MB MAX
const imageFaceValidation = 2097152;  //  2 MB MAX
const imageSize = 524288;  // 512 KB
const size20MB = 20480000;
const size50MB = 51200000;
const size1024MB = 1024000000;

const yellowColor = '#F2A100';
const blueColor = 'blue';
const greenColor = '#0C4523';
const orangeColor = 'orange';
const redColor = '#BC0000';

export { size500KB, fileSize, imageSize, imageFaceValidation, size20MB, size50MB, size1024MB, yellowColor, blueColor, greenColor, orangeColor, redColor };

export const PASSWORD_MIN_LENGTH = 6;
export const DOCUMENT_ID_MIN_LENGTH = 20;
